<template>
  <div>
    <van-nav-bar
      right-text="历史记录"
      @click-right="$router.push('/pickupList')"
    />
    <van-form validate-first :show-error="false" @submit="onSubmit">
      <div class="form-wrap">
        <van-field
          v-model="form.pickUpPerson"
          label="代接人"
          placeholder="请输入姓名"
          size="large"
          :rules="rules.pickUpPerson"
        />
        <van-field
          v-model="form.pickUpPhone"
          label="手机号"
          placeholder="请输入手机号"
          size="large"
          :rules="rules.pickUpPhone"
        />
        <van-field
          name="uploader"
          label="识别头像"
          size="large"
          center
          v-model="form.pickUpPhoto"
          :rules="rules.pickUpPhoto"
        >
          <template #input>
            <img
              src="@/assets/images/avatar.png"
              alt=""
              style="
                width: 2.75rem;
                height: 2.75rem;
                border-radius: 50%;
                object-fit: cover;
              "
              v-if="!form.pickUpPhoto"
              @click="avatarUpload"
            />
            <img
              :src="form.pickUpPhoto"
              v-else
              alt=""
              style="
                width: 2.75rem;
                height: 2.75rem;
                border-radius: 50%;
                object-fit: cover;
              "
              @click="previewImg(form.pickUpPhoto)"
            />
            <van-tag
              plain
              type="primary"
              style="margin-left: 1rem;"
              size="medium"
              @click="avatarUpload"
              v-if="form.pickUpPhoto"
              >更换</van-tag
            >
          </template>
        </van-field>
        <!-- <van-field label="班级" size="large" :rules="rules.leaveName" style="display:none;">
          <template #input>
            <van-radio-group
              v-model="form.radio"
              size="large"
              direction="horizontal"
              @change="handleClassesRadio"
            >
              <van-radio
                :name="item"
                style="margin: 0 0.5rem 0.5rem 0;"
                v-for="(item, index) in classesList"
                :key="index"
                >{{ item }}</van-radio
              >
            </van-radio-group>
          </template>
        </van-field> -->
        <van-field label="孩子" size="large" :rules="rules.childMessage">
          <template #input>
            <van-radio-group v-model="form.childMessage" direction="horizontal">
              <van-radio
                :name="item"
                style="margin-bottom: 5px;"
                v-for="(item, index) in childList"
                :key="index"
                >{{ item.name }}</van-radio
              >
            </van-radio-group>
          </template>
        </van-field>
        <!-- <van-field
          label="孩子"
          size="large"
          readonly
          :rules="rules.childMessage"
        >
          <template #input> 
            <van-checkbox-group
              v-model="form.childMessage"
            >
              <van-checkbox
                :name="item"
                v-for="(item, index) in childList"
                :key="index"
                style="margin: 0 0.5rem 0.5rem 0;"
                >{{ item.name }}</van-checkbox
              >
            </van-checkbox-group>
          </template>
        </van-field> -->
        <van-field
          v-model="form.pickUpBeginTime"
          label="开始时间"
          placeholder="点击选择"
          clickable
          readonly
          is-link
          @click="clickTime('starttime')"
          :rules="rules.pickUpBeginTime"
          size="large"
        />
        <van-field
          v-model="form.pickUpEndTime"
          label="结束时间"
          placeholder="点击选择"
          clickable
          readonly
          is-link
          :rules="rules.pickUpEndTime"
          @click="clickTime('endtime')"
          size="large"
        />

        <van-field
          type="textarea"
          placeholder="请输入原因"
          label="原因"
          v-model="form.reason"
          :rules="rules.reason"
          size="large"
        />
        <van-field
          v-model="form.teacherName"
          label="审批人"
          placeholder="请选择审批人"
          size="large"
          clickable
          readonly
          :rules="rules.teacherName"
          @click="$refs.interviewee.showiIntervieweePopup = true"
        />
      </div>
      <div style="margin: 30px 16px;">
        <van-button
          round
          block
          :loading="btn_loading"
          :disabled="btn_loading"
          :loading-text="textBtn"
          type="info"
          native-type="submit"
        >
          提交
        </van-button>
      </div>
    </van-form>

    <SelectTime
      ref="starttime"
      :typeTime="'选择开始时间'"
      @time="handleTimeStartConfirm"
      :minDate="startMinTime"
      :isFilter="false"
    />
    <SelectTime
      ref="endtime"
      :typeTime="'选择结束时间'"
      @time="handleTimeEndConfirm"
      :minDate="endMinDate"
      :isFilter="false"
      :currentDate="endCurTime"
    />
    <Interviewee
      ref="interviewee"
      @selectItem="handleSelIntervieweeItem"
      pageType="student"
    />
  </div>
</template>

<script>
import Interviewee from '@/components/subScribePopup/interviewee'
import SelectTime from '@/components/subScribePopup/selectTime'
import moment from 'moment'
import { upload } from '@/utils/upload'
import { timeFormart } from '@/utils'
import uploadImg from '@/utils/upload.service'
import assign from '@/mixins/assign'
import { ImagePreview } from 'vant'

export default {
  // mixins: [assign],

  data() {
    return {
      form: {
      // pickUpPhoto:
      //   'http://m.imeitou.com/uploads/allimg/2019102116/2wogtrs1dtu-lp.jpg',
      },
      showPicker: false,
      rules: {
        pickUpPerson: [
          {
            required: true,
            message: '请输入姓名',
          },
        ],
        pickUpPhone: [
          {
            required: true,
            message: '请输入手机号',
          },
        ],
        pickUpBeginTime: [
          {
            required: true,
            message: '请选择时间',
            trigger: 'onChange',
          },
        ],
        pickUpEndTime: [
          {
            required: true,
            message: '请选择时间',
            trigger: 'onChange',
          },
        ],
        pickUpPhoto: [
          {
            required: true,
            message: '请上传头像',
          },
        ],
        reason: [
          {
            required: true,
            message: '请输入原因',
            validator: (value, rule) => {
              rule.message = '输入字符大于50位'
              return value.length <= 50
            },
          },
        ],
        teacherName: [
          {
            required: true,
            message: '请选择审批人',
            trigger: 'onChange',
          },
        ],

        childMessage: [
          {
            required: true,
            message: '请选择孩子',
            trigger: 'onChange',
          },
        ],
      },
      addPersonFileList: [],
      btn_loading: false,
      textBtn: '提交',
      endMinDate: '',
      childList: [],
      checkboxGroup: [],
      classesChildList: [],
      classesList: [],
      startMinTime: new Date(
        moment()
          .endOf('hours')
          .add(1, 's')
      ),
    }
  },
  computed: {
    // startMinTime() {
    //   // return new Date(moment().add(1, 'h'))
    //   return new Date(
    //     moment()
    //       .endOf('hours')
    //       .add(1, 's')
    //   )
    // },
    endCurTime() {
      return new Date(moment(this.endMinDate).add(1, 'h'))
    },
  },
  mounted() {
    // this.getAllChild()
    this.getPickUpLastDetail()
    // this.$set(
    //   this.form,
    //   'pickUpBeginTime',
    //   moment()
    //     .endOf('hours')
    //     .add(1, 's')
    //     .format('YYYY-MM-DD HH:mm')
    // )

    this.getChildID()
  },
  methods: {
    previewImg(imgurl) {
      ImagePreview({
        images: [imgurl],
        closeOnPopstate: true,
      })
    },
    clickBack() {
      this.$router.go(-1)
    },
    async getChildID() {
      try {
        const { code, data } = await this.$https.getAllChild({
          userId: this.$store.state.puserId,
          schoolId: this.$store.state.pschoolId
        })
        if (code !== 200) {
          return
        }
        console.log('孩子信息',data)
        this.classesChildList = data
        //console.log('ban',this.classesChildList)

        this.classesChildList.forEach((item) => {
                this.childList.push({
                    id: item.id,
                    className: item.className,
                    name: item.name,
                  })
        })
        // this.classesList = data.children.reduce((pre, cur) => {
        //   if (!pre.includes(cur.className)) {
        //     pre.push(cur.className)
        //   }
        //   return pre
        // }, [])

        // console.log('获取孩子', data.children[0].className)

        this.$set(this.form, 'childMessage', this.childList[0])
        // console.log(data.children)
      } catch (error) {}
    },
    async getPickUpLastDetail() {
      try {
        const { code, data } = await this.$https.getPickUpLastDetail({
          userId: this.$store.state.puserId,
          schoolId: this.$store.state.pschoolId,
        })
        if (code !== 200) {
          return
        }
        const {
          teacherName,
          childMessage,
          pickUpBeginTime,
          pickUpEndTime,
          ...rest
        } = data
        let form = {}

        if (teacherName) {
          form.teacherName = teacherName
        }
        // if (childMessage) {
        //   form.childMessage = childMessage
        // }
        // if (pickUpBeginTime) {
        //   form.pickUpBeginTime = moment(pickUpBeginTime).format(
        //     'YYYY-MM-DD HH:mm'
        //   )
        // } else {

        //   // this.endMinDate = new Date(form.pickUpBeginTime.replace(/-/g, '/'))
        // }

        // if (pickUpEndTime) {
        //   form.pickUpEndTime = moment(pickUpEndTime).format('YYYY-MM-DD HH:mm')
        // }
        form.pickUpBeginTime = moment()
          .endOf('hours')
          .add(1, 's')
          .format('YYYY-MM-DD HH:mm')
        this.startMinTime = new Date(form.pickUpBeginTime.replace(/-/g, '/'))
        this.endMinDate = new Date(form.pickUpBeginTime.replace(/-/g, '/'))
        this.form = { ...form, ...rest }
      } catch (error) {}
    },
    async avatarUpload() {
      try {
        const imgUrl = await uploadImg()
        this.$set(this.form, 'pickUpPhoto', imgUrl)
      } catch (error) {
        this.$set(this.form, 'pickUpPhoto', '')
      }
    },
    onSubmit() {
      var list=[]
      this.btn_loading = true
      this.textBtn = '提交中'
      const { pickUpBeginTime, pickUpEndTime,childMessage, ...rest } = this.form
      list.push(childMessage)
      this.$https
        .savePickUp({
          ...rest,
          userId: this.$store.state.puserId,
          schoolId: this.$store.state.pschoolId,
          pickUpBeginTime: timeFormart(pickUpBeginTime),
          pickUpEndTime: timeFormart(pickUpEndTime),
        //   pickUpPhoto:
        // 'http://m.imeitou.com/uploads/allimg/2019102116/2wogtrs1dtu-lp.jpg',
          childMessage:list
        })
        .then((res) => {
          if (res.code !== 200) {
            this.$toast(res.msg)
            this.btn_loading = false
            this.textBtn = '提交'
            return
          }
          // this.$toast('成功')
          // setTimeout(() => {
          //   this.$router.go(-1)
          //   this.form = {}
          // }, 1000)
          this.$toast({
            type: 'success',
            overlay: true,
            message: '成功',
            duration: 1500,
            onClose: () => {
              this.$router.push('/pickupList')
            },
          })
        })
        .catch(() => {
          this.btn_loading = false
          this.textBtn = '提交'
        })
    },
    handleTimeStartConfirm(value) {
      console.log(value)
      this.$set(this.form, 'pickUpBeginTime', value)
      this.endMinDate = new Date(value.replace(/-/g, '/'))
      this.$refs.starttime.showTimePopup = false
      this.$refs.endtime.showTimePopup = true
    },
    handleSelIntervieweeItem(item) {
      console.log(item)
      // 更新被访人id
      this.$set(this.form, 'teacherId', item.id)
      this.$set(this.form, 'teacherName', item.name)
      // this.$set(this.form, 'auditeDeptName', item.deptName)
      this.$refs.interviewee.showiIntervieweePopup = false
    },
    handleTimeEndConfirm(value) {
      this.$set(this.form, 'pickUpEndTime', value)
      this.$refs.endtime.showTimePopup = false
    },
    clickTime(type) {
      this.$refs[type].showTimePopup = true
    },
    async afterReadPerson(file) {
      try {
        const imgUrl = await upload(file.file)
        this.$set(this.form, 'pickUpPhoto', imgUrl)
      } catch (error) {
        this.$set(this.form, 'pickUpPhoto', imgUrl)
        this.addPersonFileList = []
      }
    },
    beforeDelPerson(item, obj) {
      this.addPersonFileList.splice(obj.index, 1)
    },
    // async getAllChild() {
    //   const { code, data } = await this.$https.getAllChild({
    //     userId: this.$store.state.userId,
    //     schoolId: this.$store.state.schoolId,
    //   })
    //   if (code !== 200) {
    //     return
    //   }
    // this.childList = [
    //   {
    //     name: '盖子1',
    //   },
    //   {
    //     name: '盖子2',
    //   },
    //   {
    //     name: '盖子3',
    //   },
    //   ...data,
    // ]
    // this.$set(this.form, 'radio', data[0])
    // },
    handleClassesRadio(i) {
      //console.log('选择班级去请求孩子', i)
      this.childList = []
      this.classesChildList.forEach((item) => {
        this.childList.push({
            id: item.id,
            className: item.className,
            name: item.name,
          })
        // if (item.className == i) {
        //   this.childList.push({
        //     id: item.id,
        //     className: item.className,
        //     name: item.name,
        //   })
        // }
      })
      this.$set(this.form, 'childMessage', this.childList[0])
      //console.log('孩子信息',this.childList)
    },
  },
  components: {
    Interviewee,
    SelectTime,
  },
}
</script>

<style lang="scss" scoped>
.form-wrap {
  margin: 1rem;
  box-shadow: 0 0.25rem 1rem rgba(69, 91, 99, 0.1);
  border-radius: 0.75rem;
  overflow: hidden;
}
</style>
